import React, { useMemo } from 'react';
import {
  Checkbox,
  Popover,
  IconButton,
  Text,
  TextList,
  TextListItem,
} from '../../../design-system';
import { useTranslation } from 'react-i18next';
import {
  InfoIconWrapper,
  DescriptionText,
  CheckboxWithPopoverWrapper,
} from './CheckboxSelector.styles';
import listOfDealers from '../../constants/ListOfDealers';
import { CheckboxTypes } from './CheckboxSelector.types';
import useCheckboxSelector from '../../hooks/useCheckboxSelector';

const CheckboxSelectorAlpha: React.FC<CheckboxTypes> = ({
  value,
  checked,
  onChange,
  label,
  ariaLabel,
  inputName,
  disabled = false,
  hint,
  filterType,
}) => {
  const { t } = useTranslation();
  const { isOpen, setIsOpen, isRegionFilter, handleChange } = useCheckboxSelector({
    disabled,
    onChange,
    value,
    checked,
    filterType,
  });

  const InfoPopover = useMemo(() => {
    if (!isRegionFilter) return null;
    return (
      <InfoIconWrapper>
        <IconButton
          variant="tertiary"
          icon="info-circle"
          size="sm"
          onClick={() => setIsOpen((prev) => !prev)}
        />
        <Popover
          aria-label="Popover title"
          id="popover_title"
          triggerElement={<span />}
          open={isOpen}
          content={
            <>
              <DescriptionText>
                <Text variant={{ order: '2', style: 'normal' }}>
                  {t(`promo.filters.filterOptions.offerRegion.listOfDealers`)}
                </Text>
              </DescriptionText>
              <TextList
                size="sm"
                className="dealers-list"
                data-testid="dealers-list"
                variant="bullet"
              >
                {listOfDealers[value].map((dealer) => (
                  <TextListItem key={dealer}>{dealer}</TextListItem>
                ))}
              </TextList>
            </>
          }
          onClose={() => setIsOpen(false)}
          withTip
        />
      </InfoIconWrapper>
    );
  }, [isOpen, isRegionFilter, t, value]);

  return (
    <CheckboxWithPopoverWrapper>
      <Checkbox
        id={inputName}
        name={value}
        value={value}
        label={hint ? `${label} (${hint})` : label}
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
        aria-label={ariaLabel}
        data-testid={`${filterType}-${inputName}`}
      />
      {InfoPopover}
    </CheckboxWithPopoverWrapper>
  );
};

export default CheckboxSelectorAlpha;
